var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMonitor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26 26C26 22.9624 28.4624 20.5 31.5 20.5C34.5376 20.5 37 22.9624 37 26C37 29.0376 34.5376 31.5 31.5 31.5C28.4624 31.5 26 29.0376 26 26ZM31.5 23.5C30.1193 23.5 29 24.6193 29 26C29 27.3807 30.1193 28.5 31.5 28.5C32.8807 28.5 34 27.3807 34 26C34 24.6193 32.8807 23.5 31.5 23.5Z",
    fill: "#3DE8CA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57 16C57 14.067 55.433 12.5 53.5 12.5H9.5C7.56701 12.5 6 14.067 6 16V44C6 45.933 7.56701 47.5 9.5 47.5H30V52.5H23.5C22.6716 52.5 22 53.1716 22 54C22 54.8284 22.6716 55.5 23.5 55.5L39.5 55.5C40.3284 55.5 41 54.8284 41 54C41 53.1716 40.3284 52.5 39.5 52.5H33V47.5H53.5C55.433 47.5 57 45.933 57 44V16ZM42.9646 44.5H53.5C53.7761 44.5 54 44.2761 54 44V16C54 15.7239 53.7761 15.5 53.5 15.5L9.5 15.5C9.22386 15.5 9 15.7239 9 16L9 44C9 44.2761 9.22386 44.5 9.5 44.5H20.0354C20.0121 44.3367 20 44.1698 20 44V42C20 37.8579 23.3579 34.5 27.5 34.5H35.5C39.6421 34.5 43 37.8579 43 42V44C43 44.1698 42.9879 44.3367 42.9646 44.5ZM23.5 44.5H39.5C39.7761 44.5 40 44.2761 40 44V42C40 39.5147 37.9853 37.5 35.5 37.5H27.5C25.0147 37.5 23 39.5147 23 42V44C23 44.2761 23.2239 44.5 23.5 44.5Z",
    fill: "#3DE8CA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonitor);
export default __webpack_public_path__ + "static/media/monitor.8482304dba188eb346765dd927812b43.svg";
export { ForwardRef as ReactComponent };